import * as React from 'react'
import { View } from 'react-native'
import styled from '@theme/styled-components'

import { RecyclerListView, DataProvider, LayoutProvider } from 'recyclerlistview'

interface Props<T> {
  data: T[]
  renderItem: (item: T, idx: number) => React.ReactElement
  height: number
  size?: { width: number; height: number }
  didItemChanged?: (a: T, b: T) => boolean
}

const InfiniteList: <T>(props: Props<T>) => React.ReactElement = ({
  data,
  height,
  size = { width: 0, height: 0 },
  renderItem,
  didItemChanged = (a, b) => a !== b,
}) => {
  const [containerSize, setContainerSize] = React.useState(size)

  const layoutProvider = React.useMemo(
    () =>
      new LayoutProvider(
        () => 'LAYOUT',
        (type, dim) => {
          dim.width = containerSize.width
          dim.height = height
        }
      ),
    [height, containerSize]
  )

  const Provider = new DataProvider(didItemChanged)
  const dataProvider = React.useMemo(() => Provider.cloneWithRows(data), [data])

  const renderRow = (type: string | number, item: (typeof data)[number], index: number) => renderItem(item, index)

  if (containerSize.height === 0) {
    return (
      <Empty
        onLayout={(evt) =>
          setContainerSize({ height: evt.nativeEvent.layout.height, width: evt.nativeEvent.layout.width })
        }
      />
    )
  }

  return (
    <RecyclerListView
      style={{ height: containerSize.height, width: containerSize.width }}
      dataProvider={dataProvider}
      layoutProvider={layoutProvider}
      rowRenderer={renderRow}
    />
  )
}

export default InfiniteList

const Empty = styled(View)`
  flex: 1;
`
